import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ProfileService } from "../../../../services/ProfileService";
import { JobService } from "../../../../services/JobService";
import { Button } from "reactstrap";
import { isNullOrEmpty } from "../../../../config/ENV";
import {formatPhoneNumber} from "../../../../utilities/phoneutility";
import { Stringutility } from "../../../../utilities/stringutility";
import { Constants } from "../../../../constants/constantValues";
const Rating = () => {
  const location = useLocation();
  const [peerRatingList, setPeerRatingList] = useState([]);
  const [ratingCount, setRatingCount] = useState();
  const history = useHistory();
  const [modalRight, setModalRight] = useState(false);

  const [peerContactNumber, setPeerContactNumber] = useState("");
  const [selectionId, setSelectionId] = useState("");
  const [showPersonal, setShowPersonal] = useState(false);
  const [showEmployer, setShowEmployer] = useState(false);
  const [experiencesList, setExperiencesList] = useState([]);
  const [requestId, setRequestId] = useState("");

  const [workedSameTeam, setWorkedSameTeam] = useState(false);
  const [workedDiffTeams, setWorkedDiffTeams] = useState(false);
  const [youSupervisedPeer, setYouSupervisedPeer] = useState(false);
  const [b2bRelation, setB2bRelation] = useState(false);
  const [customerRelation, setCustomerRelation] = useState(false);
  const [peerSupervisedYou, setPeerSupervisedYou] = useState(false);
  const [mentoringOrTraining, setMentoringOrTraining] = useState(false);
  const [academicRelation, setAcademicRelation] = useState(false);
  const [personalRelation, setPersonalRelation] = useState(false);
  const [expId, setExpId] = useState("");
  const [showButton, setShowButton] = useState(true);
  const [peerRewquestEnabled, setpeerRewquestEnabled] = useState(false);
  const [inputField, setInputField] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    description: "",
  });
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [email, setEmail] = useState("");
  const [countryCode, setcountryCode] = useState("");

  useEffect(() => {
    getReviewDetails();
    getPeerRating();
    getCandidateExperiences();
  }, []);

  useEffect(() => {
    let firstName=Stringutility.getValue(location.state.firstName);
    let lastName=Stringutility.getValue(location.state.lastName);
    let email=Stringutility.getValue(location.state.email);
    let contactNumber=Stringutility.getValue(location.state.contactNumber);
    let countryCode=Stringutility.getValue(location.state.countryCode);

    setFirstName(firstName);
    setLastName(lastName);
    setEmail(email);
    setContactNumber(contactNumber);
    setcountryCode(countryCode);
  }, [location]);

  const checkSkills = () => {
    JobService.skillVerification().then((response) => {
      try {
        var skillDetails = response.data;
        if (skillDetails != null) {
          var isSkilled=skillDetails.skilled;
          if(isSkilled){
            sendPeerRating();
          }else{
            Stringutility.showErrorMessage(Constants.skillsNotAddedIntoYourProfile);
          }         
        }
      } catch (err) {
        console.error("skillVerification" + JSON.stringify(err));
      }
    });
  };

  const getReviewDetails = () => {
    const peerReqStatus = "";
    ProfileService.getRatingReview(peerReqStatus).then((response) => {
      try {
        var peerRatingDetails = response.data;
        if (peerRatingDetails != null) {
          if (peerRatingDetails.reqList.length > 0) {
            setPeerRatingList(peerRatingDetails.reqList);
          }
        }
      } catch (err) {
        console.error("getRatingReview" + JSON.stringify(err));
      }
    });
  };

  const handleSelectionChange = (e) => {
    setSelectionId(e.target.value);
    if (e.target.value == "personal") {
      setShowPersonal(true);
      setPersonalRelation(true);
      setShowEmployer(false);
      setExpId("");
    } else if (e.target.value == "") {
      setShowPersonal(false);
      setShowEmployer(false);
      setExpId("");
    } else {
      setShowPersonal(true);
      setShowEmployer(true);
      setExpId(e.target.value);
    }
  };

  const updateWorkedSameTeam = () => {
    setWorkedSameTeam(!workedSameTeam);
  };
  const updateworkedDiffTeams = () => setWorkedDiffTeams(!workedDiffTeams);
  const updateYouSupervisedPeer = () =>
    setYouSupervisedPeer(!youSupervisedPeer);
  const updatePeerSupervisedYou = () =>
    setPeerSupervisedYou(!peerSupervisedYou);
  const updateB2BRelation = () => setB2bRelation(!b2bRelation);
  const updateMentoringOrTraining = () =>
    setMentoringOrTraining(!mentoringOrTraining);
  const updateCustomerRelation = () => setCustomerRelation(!customerRelation);
  const updateAcademicRelation = () => setAcademicRelation(!academicRelation);

  const sendPeerRequest = (event) => {
    setShowButton(false);
    // if (selectionId == 0) {
    //   toast.error("Please select how do you know this person");
    //   return;
    // }
     checkSkills();
  };

  const sendPeerRating = () => {
    var peerContactNumber = "";
    if (!isNullOrEmpty(contactNumber)) {

      
      peerContactNumber = countryCode + "" + contactNumber;
    } else {
      peerContactNumber = "";
    }

    const peerRequest = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      contactNumber: peerContactNumber,
      workedSameTeam: workedSameTeam,
      youSupervisedPeer: youSupervisedPeer,
      b2bRelation: b2bRelation,
      customerRelation: customerRelation,
      workedDiffTeams: workedDiffTeams,
      peerSupervisedYou: peerSupervisedYou,
      mentoringOrTraining: mentoringOrTraining,
      academicRelation: academicRelation,
      personalMessage: inputField.description,
      personalRelation: personalRelation,
      experienceId: expId,
    };

    if (requestId == "") {
      setpeerRewquestEnabled(true);
      ProfileService.addPeerRating(peerRequest).then((response) => {
        setpeerRewquestEnabled(false);
        try {
          // toast.success("Peer request added successfully");
          history.push("/jobs");

          setInputField((prevState) => ({
            ...prevState,
            firstName: "",
            lastName: "",
            email: "",
          }));
          setPeerContactNumber("");
          getReviewDetails();
        } catch (err) {
          console.error("addPeerRating" + JSON.stringify(err));
        }
      });
    } else {
      ProfileService.updatePeerRating(peerRequest, requestId).then(
        (response) => {
          try {
            Stringutility.showSuccessMessage(Constants.peerRequestUpdated);
            setInputField((prevState) => ({
              ...prevState,
              firstName: "",
              lastName: "",
              email: "",
            }));
            setPeerContactNumber("");
            getReviewDetails();
          } catch (err) {
            console.error("updatePeerRating" + JSON.stringify(err));
          }
        }
      );
    }
  };

  const inputsHandler = (e) => {
    const { name, value } = e.target;
    setInputField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const getCandidateExperiences = () => {
    ProfileService.getExperience().then((response) => {
      try {
        var experienceDetails = response.data;
        if (experienceDetails !== null) {
          if (experienceDetails.exps != null) {
            var explist = [...experiencesList];
            response.data.exps.length > 0 &&
              response.data.exps.map((experience) => {
                const obj = {
                  key: experience.id,
                  value: experience.employer,
                };
                explist.push(obj);
              });
          }
          setExperiencesList(explist);
        }
      } catch (err) {
        console.error("getExperience" + JSON.stringify(err));
      }
    });
  };
 

  const getPeerRating = () => {
    ProfileService.getRating().then((response) => {
      try {
        var peerRatinhDetails = response.data;
        if (peerRatinhDetails != null) {
          setRatingCount(response.data.size);
        }
      } catch (err) {
        console.error("getRating" + JSON.stringify(err));
      }
    });
  };
  const goBack = () => {
    history.push("/peerrating");
  };
  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <>
      {/* Column One Start   */}
      <div className=" min-sm:col-span-2 max-sm:col-span-full ">
        <div
          href="#"
          onClick={goBack}
          className="backArrow min-sm:hidden max-sm:absolute max-sm:left-4 max-sm:-mt-11 t-back-but-padd "
        >
          <svg
            width="10"
            height="18"
            viewBox="0 0 10 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.53033 0.96967C9.82322 1.26256 9.82322 1.73744 9.53033 2.03033L2.56066 9L9.53033 15.9697C9.82322 16.2626 9.82322 16.7374 9.53033 17.0303C9.23744 17.3232 8.76256 17.3232 8.46967 17.0303L0.96967 9.53033C0.676777 9.23744 0.676777 8.76256 0.96967 8.46967L8.46967 0.96967C8.76256 0.676777 9.23744 0.676777 9.53033 0.96967Z"
              fill="white"
            />
          </svg>
        </div>

        <h1 className="text-2xl font-bold min-sm:mb-7 max-sm:mb-12 max-sm:pl-4 max-sm:-mt-[54px] max-sm:text-center max-sm:text-primary-white t-back-arrow-but-pad">
          Ask peers to rate you
        </h1>
        {/* Peer Invitation Section Start   */}
        <div className="peerInvitation-container ">
          {/* Form Start  */}
          <div className="px-7 pb-8 max-sm:px-5">
            <div className="bg-white border border-solid border-primary-gray2 rounded-lg p-4 mb-7 px-5 rounded-card">
              <h3 className="font-bold text-xl">
                {capitalizeFirst(firstName) + "  " + lastName}
              </h3>
              {email != "" && (
                <div className="font-normal text-sm flex flex-wrap gap-2 items-center py-2">
                  <svg
                    className="inline"
                    width="14"
                    height="10"
                    viewBox="0 0 14 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.5 0.5C0.5 0.223858 0.723858 8.24167e-09 1 8.24167e-09H13C13.2761 8.24167e-09 13.5 0.223858 13.5 0.5V9C13.5 9.26521 13.3946 9.51957 13.2071 9.70711C13.0196 9.89464 12.7652 10 12.5 10H1.5C1.23478 10 0.98043 9.89464 0.792893 9.70711C0.605357 9.51957 0.5 9.26522 0.5 9V0.5ZM1.5 1V9H12.5V1H1.5Z"
                      fill="#1F9DFC"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.631426 0.162141C0.818022 -0.0414189 1.13431 -0.0551703 1.33787 0.131426L7 5.32172L12.6621 0.131426C12.8657 -0.0551703 13.182 -0.0414189 13.3686 0.162141C13.5552 0.3657 13.5414 0.681984 13.3379 0.86858L7.33787 6.36858C7.1467 6.54381 6.8533 6.54381 6.66214 6.36858L0.662141 0.86858C0.458581 0.681984 0.44483 0.3657 0.631426 0.162141Z"
                      fill="#1F9DFC"
                    />
                  </svg>
                  {email}
                </div>
              )}
              {contactNumber != "" && (
                <div className="font-normal text-sm flex flex-wrap gap-2 items-center py-2">
                  <svg
                    width="10"
                    height="14"
                    viewBox="0 0 10 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M2 1C1.72386 1 1.5 1.22386 1.5 1.5V12.5C1.5 12.7761 1.72386 13 2 13H8C8.27614 13 8.5 12.7761 8.5 12.5V1.5C8.5 1.22386 8.27614 1 8 1H2ZM0.5 1.5C0.5 0.671573 1.17157 0 2 0H8C8.82843 0 9.5 0.671573 9.5 1.5V12.5C9.5 13.3284 8.82843 14 8 14H2C1.17157 14 0.5 13.3284 0.5 12.5V1.5Z"
                      fill="#1F9DFC"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.5 2.5C0.5 2.22386 0.723858 2 1 2H9C9.27614 2 9.5 2.22386 9.5 2.5C9.5 2.77614 9.27614 3 9 3H1C0.723858 3 0.5 2.77614 0.5 2.5Z"
                      fill="#1F9DFC"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.5 11.5C0.5 11.2239 0.723858 11 1 11H9C9.27614 11 9.5 11.2239 9.5 11.5C9.5 11.7761 9.27614 12 9 12H1C0.723858 12 0.5 11.7761 0.5 11.5Z"
                      fill="#1F9DFC"
                    />
                  </svg>
                  {formatPhoneNumber(contactNumber)}
                </div>
              )}
            </div>

            <div className="relationship">
              <h4 className="font-bold text-sm my-3">
                How do you know{" "}
                {
                  capitalizeFirst(firstName)                 
                }{" "}
                ?
              </h4>
              <select
                className="form-select w-full px-3 py-2 text-sm font-normal text-primary-dark bg-white bg-clip-padding border border-solid border-primary-gray2 rounded-lg min-sm:w-1/2 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none px-5 pad-2 rounded-card"
                id=""
                name=""
                form=""
                onChange={handleSelectionChange}
              >
                <option value="">Please select</option>                
                {experiencesList.length > 0 &&
                  experiencesList.map(({ value, key }) => (
                    <option value={key} key={key}>
                      {value}
                    </option>
                  ))}
              </select>
            </div>

            {/* Checkbox Wrapper Start  */}

            {showEmployer && (
              <div className="w-full bg-white shadow rounded-xl p-6 my-6 shd_peer">
                <h4 className="font-bold text-sm">
                  Please verify your relationship. Check all that apply.
                </h4>
                <div className=" font-normal text-sm my-3">
                  <ul className="px-5">
                    <li className="my-2">
                      <label
                        className="form-check-label"
                        htmlFor="workedInSameTeam"
                      >
                        <input
                          className="form-check-input appearance-none h-3 w-3 mt-1 align-top mr-2 border border-Gray-500 bg-white checked:bg-primary-blue checked:border-primary-white focus:outline-none transition duration-200 cursor-pointer border_color_peer"
                          type="checkbox"
                          id="workedInSameTeam"
                          checked={workedSameTeam}
                          onChange={updateWorkedSameTeam}
                        />
                        Worked in the same team
                      </label>
                    </li>
                    <li>
                      <label
                        className="form-check-label"
                        htmlFor="youSupervised"
                      >
                        <input
                          className="form-check-input appearance-none h-3 w-3 mt-1 align-top mr-2 border border-Gray-500 bg-white checked:bg-primary-blue checked:border-primary-white focus:outline-none transition duration-200 cursor-pointer border_color_peer"
                          type="checkbox"
                          id="youSupervised"
                          checked={youSupervisedPeer}
                          onChange={updateYouSupervisedPeer}
                        />
                        You supervised {capitalizeFirst(firstName)}
                      </label>
                    </li>
                    <li className="my-2">
                      <label
                        className="form-check-label"
                        htmlFor="supervisedYou"
                      >
                        <input
                          className="form-check-input appearance-none h-3 w-3 mt-1 align-top mr-2 border border-Gray-500 bg-white checked:bg-primary-blue checked:border-primary-white focus:outline-none transition duration-200 cursor-pointer border_color_peer"
                          type="checkbox"
                          id="supervisedYou"
                          checked={peerSupervisedYou}
                          onChange={updatePeerSupervisedYou}
                        />
                        {capitalizeFirst(firstName)} supervised you
                      </label>
                    </li>
                    <li className="my-2">
                      <label
                        className="form-check-label"
                        htmlFor="b2bRelationship"
                      >
                        <input
                          className="form-check-input appearance-none h-3 w-3 mt-1 align-top mr-2 border border-Gray-500 bg-white checked:bg-primary-blue checked:border-primary-white focus:outline-none transition duration-200 cursor-pointer border_color_peer"
                          type="checkbox"
                          id="b2bRelationship"
                          checked={b2bRelation}
                          onChange={updateB2BRelation}
                        />
                        Business to business relationship
                      </label>
                    </li>
                    <li className="my-2">
                      <label
                        className="form-check-label"
                        htmlFor="mentoringRelationship"
                      >
                        <input
                          className="form-check-input appearance-none h-3 w-3 mt-1 align-top mr-2 border border-Gray-500 bg-white checked:bg-primary-blue checked:border-primary-white focus:outline-none transition duration-200 cursor-pointer border_color_peer"
                          type="checkbox"
                          id="mentoringRelationship"
                          checked={mentoringOrTraining}
                          onChange={updateMentoringOrTraining}
                        />
                        Mentoring or training relationship
                      </label>
                    </li>
                    <li className="my-2">
                      <label
                        className="form-check-label"
                        htmlFor="customerRelationship"
                      >
                        <input
                          className="form-check-input appearance-none h-3 w-3 mt-1 align-top mr-2 border border-Gray-500 bg-white checked:bg-primary-blue checked:border-primary-white focus:outline-none transition duration-200 cursor-pointer border_color_peer"
                          type="checkbox"
                          id="customerRelationship"
                          checked={customerRelation}
                          onChange={updateCustomerRelation}
                        />
                        Customer relationship
                      </label>
                    </li>
                    <li className="my-2">
                      <label
                        className="form-check-label"
                        htmlFor="academicRelationship"
                      >
                        <input
                          className="form-check-input appearance-none h-3 w-3 mt-1 align-top mr-2 border border-Gray-500 bg-white checked:bg-primary-blue checked:border-primary-white focus:outline-none transition duration-200 cursor-pointer border_color_peer"
                          type="checkbox"
                          id="academicRelationship"
                          checked={academicRelation}
                          onChange={updateAcademicRelation}
                        />
                        Academic relationship
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            )}
            {/* Checkbox Wrapper End  */}

            <h4 className="font-bold text-sm my-3">
              Include a personalized message with your request:
            </h4>

            {/* MessageBox Wrapper Start  */}
            <div className="flex justify-center">
              <div className="mb-3 w-full">
                <textarea
                  className="form-control block w-full px-5 py-4 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded-xl transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none rounded-lg card_control rounded-card"
                  id="messageTextarea "
                  rows="3"
                  placeholder="Would you please rate my skills. I am building my profile on Teamanics – a peer network to grow my career. Employers trust skill ratings from a group of peers as much as a personal referral. Ratings are only of skills. There is no rating of a person. "
                  name="description"
                  onChange={inputsHandler}
                  value={inputField.description}
                ></textarea>
              </div>
            </div>
            {/* MessageBox Wrapper End  */}

            <div className="max-sm:flex max-sm:flex-wrap">
              <div className="basis-full continue-button  inline">
                <Button
                  type="submit"
                  color="primary"
                  outline
                  onClick={sendPeerRequest}
                  disabled={peerRewquestEnabled}
                  // className="save bg-primary-blue rounded-full text-[16px] text-white font-semibold text-center my-2 inline-block px-10 py-2 hover:bg-Blue-900 hover:shadow-lg focus:bg-blue-900 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-primary-blue2 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Done With Peerrating
                </Button>
              </div>
            </div>
          </div>
          {/* Form End  */}
        </div>
        {/* Peer Invitation Section End   */}
      </div>
      {/* Column One End   */}
    </>
  );
};
export default Rating;
